import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import {  Grid } from '@mui/material'
import { usePOST_privateNoteMutation } from 'redux/api/privateNotesApi'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import RichTextField from 'components/atoms/fields/RichTextField'
import InputField from 'components/atoms/fields/InputField'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import formModel, { initialValues, validationSchema } from 'utils/formModels/privateNoteModel'

interface IProps {
  assignmentId?: string
  onCreate?: any
}

const PrivateNoteForm: FC<IProps> = ({ assignmentId, onCreate }) => {
  const { t } = useTranslation()

  const { text, title } = formModel()

  const [
    addEntity,
    { isLoading: createLoading, isSuccess: createSuccess, error: createError, data: addResponseData },
  ] = usePOST_privateNoteMutation()

  useErrorAlert(createError)
  useSuccessAlert(createSuccess ? t('alerts.message-sent') : '')

  useEffect(() => {
    if(createSuccess)
      onCreate();
  }, [createSuccess])


  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {
        addEntity({ assignment_id: assignmentId, body: { 
         ...values
        } })
      }}
    >
      {({ values}) => {
        return (
          <Form>
            <Grid container spacing={3} sx={{ marginTop: '0px' }}>
              <Grid item xs={12}>
                <InputField fieldProps={{ ...title }} />
              </Grid>
              <Grid item xs={12}>
                <RichTextField
                  width={'100%'}
                  fieldProps={{...text}}
                  label={text.label}
                />
              </Grid>
              <Grid item xs={12}>
                <SubmitButton
                  color={'success'}
                  text={`${t('common.save')}`}
                  sx={{ width: '150px' }}
                  isLoading={createLoading}
                  alignRight={false}
                />
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default PrivateNoteForm
